import axios from 'axios';

import { MainUrl } from "../constants"

const API_URL = `${MainUrl}/group_station`

export const getMyGroupStaion = async (token) => {
    

  const response = await axios.get(`${API_URL}/my_area_group_station_obj/`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data
};
